import {
  FETCH_CATEGORY_DETAILS_BEGIN,
  FETCH_CATEGORY_DETAILS_SUCCESS,
  FETCH_CATEGORY_DETAILS_FAILURE,
  GET_ACTIVE_CATEGORY,
  MOBILE_EXPAND_CATEGORY_DETAILS
} from '../constants/categoryActionTypes';

const initialState = {
  categoryList: [],
  isLoading: true,
  error: {},
  activeCategory: '',
  mobileExpand: '',
  selectedCategory: null
}

export default function (state, action) {
  if (typeof state === 'undefined') {
    state = initialState;
  }
  switch (action.type) {
    case FETCH_CATEGORY_DETAILS_BEGIN:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_CATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        categoryList: action.payload.result,
        isLoading: false,
        selectedCategory: action.payload.categoryId,
        activeCategory: action.payload.activeCategory,
        mobileExpand: action.payload.categoryId ? Number(action.payload.categoryId) : ''
      };
    case FETCH_CATEGORY_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case GET_ACTIVE_CATEGORY:
      return {
        ...state,
        selectedCategory: null,
        activeCategory: state.categoryList.find(val => val.tid === action.payload)
      }
    case MOBILE_EXPAND_CATEGORY_DETAILS:
      return {
        ...state,
        mobileExpand: Number(state.mobileExpand) === Number(action.payload) ? '' : Number(action.payload)
      }
    default:
      return state;
  }
}
